
<form [nbSpinner]="loading"
nbSpinnerStatus="danger"
nbSpinnerSize="large"
nbSpinnerMessage="Guardando usuario...">
<div class="row">
<div class="col-md-12">
  <nb-card>
    <nb-card-header>
      <nav class="navbar navigation">
        <span><nb-icon icon="people"></nb-icon> Datos del usuario - {{userdata.email}}</span>
        <button nbButton status="primary" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
        </button>

      </nav>

    </nb-card-header>

    <nb-card-body>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="username" class="label">Nombre</label>
            <input type="text" nbInput fullWidth id="username" name="username" [(ngModel)]="userdata.name"/>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="usersurname" class="label">Apellidos</label>
            <input type="text" nbInput fullWidth id="usersurname" name="usersurname" [(ngModel)]="userdata.surname"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="contactmail" class="label">Email de contacto</label>
            <input type="email" nbInput fullWidth id="contactmail" placeholder="usuario@dominio.com" name="contactmail" [(ngModel)]="userdata.email">
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="contactphone" class="label">Teléfono de contacto</label>
            <input type="phone" nbInput fullWidth id="contactphone" name="contactphone" [(ngModel)]="userdata.phone" >
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label for="role" class="label">Rol de usuario</label><br/>
            <nb-select placeholder="Rol de usuario" fullWidth name="role" [(ngModel)]="userdata.role">
              <nb-option [value]="item" *ngFor="let item of rolesdeusuario">{{item}}</nb-option>
            </nb-select>

          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="password" class="label">Contraseña</label>
            <input type="password" nbInput fullWidth id="password" name="password" [(ngModel)]="userdata.password" >
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="account_disabled" class="label">Cuenta Desactivada</label><br/>
            <nb-checkbox name="account_disabled" [(ngModel)]="userdata.account_disabled">Cuenta desactivada</nb-checkbox>

          </div>
        </div>
      </div>

    </nb-card-body>
  </nb-card>
</div>



</div>
<div class="row">
  <div class="col-md-12">
    <button nbButton fullWidth status="primary" (click)="guardar()" ><nb-icon icon="save"></nb-icon>Guardar</button>
  </div>

</div>
</form>

